import RotateIcon from '@/common/assets/icons/rotateIcon.svg?react';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import {
  CameraRotateModalLoading,
  cameraRotateModalProps,
  cameraRotateProps,
} from '@/common/components/camera/components/modals/cameraRotateModal/cameraRotateModal.type';
import React from 'react';
import { Box } from 'styled-system/jsx';
export default ({
  open,
  onClose,
  loading,
}: cameraRotateModalProps & CameraRotateModalLoading) => {
  return (
    <MainModal closeModal={onClose} open={open}>
      <RotateModal onClose={onClose} loading={loading} />
    </MainModal>
  );
};
const RotateModal: React.FC<cameraRotateProps & CameraRotateModalLoading> = ({
  onClose,
  loading,
}) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap="1rem">
      <RotateIcon />
      {window.localStorage.getItem('is_from_app') ? (
        <Typography color="black-1">
          لطفا گوشی خود را به حالت افقی بچرخانید تا فرآیند عکس‌برداری آغاز شود.
        </Typography>
      ) : (
        <Typography color="black-1">
          لطفاً ابتدا گزینه چرخش خودکار (Auto Rotate) را غیرفعال کنید. نوار
          بالای گوشی خود را پایین بکشید و گزینه چرخش تصویر را خاموش کنید. سپس
          گوشی خود را به حالت افقی بچرخانید تا فرآیند عکس برداری آغاز شود.
        </Typography>
      )}
      <LoadingButton
        loading={loading}
        onClick={onClose}
        fullWidth
        color="primary"
      >
        تایید
      </LoadingButton>
    </Box>
  );
};
